export interface ImageResponse {
  id: number
  title: string
  imageUrl: string
}

export enum Sex {
  Unknown = 0,
  Female = 1,
  Male = 2,
  Trans = 3
}

export type ModelLanguageCode = 'ru' | 'en';

export interface ModelProfileText {
  name: string;
  description: string;
  character: string;
  interests: string;
  profession: string;
  age: number;
  location: string;
  skills: string;
}

export interface ModelProfilesResponse {
  realism?: Record<string, ModelProfileText>;
  roleplay?: Record<string, ModelProfileText>;
}

export interface ModelResponse {
  id: number
  name: string
  description: string
  character: string
  interests: string
  profession: string
  age: number
  location: string
  avatarUrl: string
  sex: Sex
  images: ImageResponse[]
  sexPreferences: number[]
  skills: string
  hasRoleplay?: boolean
  hasRealism?: boolean
  profiles?: ModelProfilesResponse
}

export interface ModelsResponse {
  models: ModelResponse[]
}
